import React from 'react';

import { TIMESTAMP, DATE } from '../formats';
import formatTimestamp from './helpers/formatTimestamp';
import formatDate from './helpers/formatDate';

export const formatInteger = (data, format) => {
  switch (format) {
    case TIMESTAMP:
      return <>{formatTimestamp(data)}</>;
    case DATE:
      return <>{formatDate(data)}</>;
    default:
      return <>{parseInt(data, 10)}</>;
  }
};

export default formatInteger;